import type { RxJsonSchema } from 'rxdb'

/**
 * Label Document Type (Denormalized for RxDB)
 */
export interface LabelDocument {
  id: string
  envId: string
  name: string
  color: string
  description?: string | null
  projectId?: string | null
  labelGroupId?: string | null
  sortOrder?: string | null
  isDeleted: boolean

  // Audit fields
  createdOn: number
  createdBy: string
  updatedOn: number
  updatedBy: string
  deletedOn?: number | null
  deletedBy?: string | null

  // RxDB replication metadata
  updatedAt?: number
}

/**
 * RxDB Schema for Label
 */
export const labelSchema: RxJsonSchema<LabelDocument> = {
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      type: 'string',
      maxLength: 36,
    },
    envId: {
      type: 'string',
      maxLength: 36,
    },
    name: {
      type: 'string',
      maxLength: 100,
    },
    color: {
      type: 'string',
      maxLength: 20,
    },
    description: {
      type: ['string', 'null'],
      maxLength: 500,
    },
    projectId: {
      type: ['string', 'null'],
      maxLength: 36,
    },
    labelGroupId: {
      type: ['string', 'null'],
      maxLength: 36,
    },
    sortOrder: {
      type: ['string', 'null'],
      maxLength: 50,
    },
    isDeleted: {
      type: 'boolean',
      default: false,
    },

    // Audit fields
    createdOn: {
      type: 'number',
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
    createdBy: {
      type: 'string',
      maxLength: 36,
    },
    updatedOn: {
      type: 'number',
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
    updatedBy: {
      type: 'string',
      maxLength: 36,
    },
    deletedOn: {
      type: ['number', 'null'],
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
    deletedBy: {
      type: ['string', 'null'],
      maxLength: 36,
    },

    // RxDB replication metadata
    updatedAt: {
      type: 'number',
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
  },
  required: [
    'id',
    'envId',
    'name',
    'color',
    'isDeleted',
    'createdOn',
    'createdBy',
    'updatedOn',
    'updatedBy',
  ],
  indexes: ['envId', 'updatedOn', ['envId', 'isDeleted']],
}
